export default __webpack_public_path__ + "static/media/media.9b31ea90.png";